import { useMemo } from 'react';
import {
  getmaxAnswerableQuestions,
  getAllAnswersBySection,
  getAllMarkedQuestions
} from '@selectors/quizTaking';
import { useSelectorWithShallowEqual } from '@hooks/reduxHooks';
import useOngoingSection from './useOngoingSection';

const useSummary = (sectionUID) => {
  const answersBySection = useSelectorWithShallowEqual(getAllAnswersBySection);
  const maxAnswerableQuestionBySection = useSelectorWithShallowEqual(
    getmaxAnswerableQuestions
  );
  const markedQuestionsBySection = useSelectorWithShallowEqual(
    getAllMarkedQuestions
  );

  const { onGoingSectionUID } = useOngoingSection();
  const UIDToProcess = sectionUID || onGoingSectionUID;

  return useMemo(() => {
    const getCount = (data) =>
      UIDToProcess
        ? Object.keys(data[UIDToProcess]).length
        : Object.keys(data).reduce(
            (sum, currentSectionUID) =>
              sum + Object.keys(data[currentSectionUID]).length,
            0
          );

    const questionsAnswered = getCount(answersBySection);
    const questionsMarked = getCount(markedQuestionsBySection);

    const maxQuestionsToAnswer = UIDToProcess
      ? maxAnswerableQuestionBySection[UIDToProcess]
      : Object.keys(maxAnswerableQuestionBySection).reduce(
          (sum, currentSectionUID) =>
            sum + maxAnswerableQuestionBySection[currentSectionUID],
          0
        );

    return {
      marked: questionsMarked,
      unanswered: maxQuestionsToAnswer - questionsAnswered,
      answered: questionsAnswered
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [UIDToProcess, answersBySection, markedQuestionsBySection]);
};

export default useSummary;
